import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import StrategicMuti from '../../../widgets/Strategic/StrategicMuti'
import ProjectDataTable from '../../../widgets/dataTable/ProjectDataTable'
import {
  getStrategySchema,
  getStrategyData,
  getSchemaStrategic,
} from '../../../redux/actions/strategic'
import { handleOnChangeIsEdit } from '../../../utils/widget'
import Strategic from '../../../widgets/Strategic/Strategic'
import scrollToComponent from 'react-scroll-to-component'
import { Message, Row } from 'rsuite'
import { useDispatch, useSelector } from 'react-redux'
import { getSchemaMultiReviewSidebar } from '../../../redux/actions/sidebar'

export default function ProposalStrategicMuti() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [isReLoading, setIsReLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [proposalStrategic, setProposalStrategic] = useState()
  const [section, setSection] = useState()
  const [dataTableSection, setDataTableSection] = useState()
  const [singleProject, setSingleProject] = useState()
  const [singleError, setSingleError] = useState()
  const [projectIdList, setProjectIdList] = useState()
  const [requestBody, setRequestBody] = useState()
  const [projectList, setProjectList] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  // const isEnableEdit = isNewMultiReveiw('multi-reveiw')
  //const isEnableEdit = isNewMultiReveiw(projectId)
  const dispatch = useDispatch()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      //let request = getRequestBody()

      let request = {
        groupId: projectId,
      }
      //console.log('handleGetSchema request', request)
      setProposalStrategic('')
      setSingleProject('')
      const _schema = await getStrategySchema(request, 5, 1)
      // const _schema = mock
      //console.log('handleGetSchema response', _schema)
      setSchema(_schema)
      setProjectList(_schema?.forms?.projectList)
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSingleSubmit = async (obj) => {
    console.log('obj', obj)
    setSingleError(false)
    startLoading()
    try {
      setProposalStrategic('')
      setSingleProject(obj)
      const response = await getSchemaStrategic(obj.id)
      // console.log('response', response)

      let _schema = response?.model?.forms?.ProjectStrategy

      if (_schema) {
        _schema['header'] = obj.projectName
        setProposalStrategic(_schema)
        console.log()
        setIsEditWidget({
          //strategic: _schema?.optionSelected?.length > 0 || !isEnableEdit ? false : true,
          strategic: _schema?.optionSelected?.length > 0,
        })
        scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
      }
    } catch (e) {
      console.log('e', e)
      setSingleError(true)
    }

    doneLoading()
  }

  const handleReload = async (pagesize, pagenumber) => {
    setIsReLoading(true)
    startLoading()
    try {
      //let request = getRequestBody()
      let request = {
        groupId: projectId,
      }

      //console.log('handleReload request', request, 'pagesize', pagesize, 'pagenumber', pagenumber)
      setProposalStrategic('')
      setSingleProject('')
      const response = await getStrategyData(request, pagesize, pagenumber)
      setProjectList(response)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsReLoading(false)
  }

  const onComplete = async () => {
    scrollToComponent(dataTableSection, { offset: 0, align: 'top', duration: 500 })
    await dispatch(getSchemaMultiReviewSidebar(projectId))
    handleGetSchema(5, 1)
  }

  // const getRequestBody = () => {
  //   let request = requestBody
  //   if (!request) {
  //     let idList = sessionStorage.getItem('mutiReview')
  //     request = {
  //       id: idList,
  //     }
  //   }
  //   setProjectIdList(request.id.split(','))
  //   setRequestBody(request)
  //   return request
  // }

  return (
    <SidebarProposal isMultiReview>
      {error ? (
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      ) : (
        <>
          {!schema || isLoading ? (
            <PanalLoadingTemplate />
          ) : (
            <>
              <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

              {
                //isEnableEdit &&
                schema.forms?.mutiGoalTenYear && (
                  <>
                    <StrategicMuti
                      schema={schema.forms?.mutiGoalTenYear}
                      // projectIdList={projectIdList}
                      onComplete={onComplete}
                    />
                    <br />
                  </>
                )
              }

              <Row
                ref={(section) => {
                  setDataTableSection(section)
                }}
              ></Row>
              {projectList && (
                <>
                  <ProjectDataTable
                    schema={projectList}
                    single={{
                      enable: true,
                      buttonText: 'บันทึกยุทธศาสตร์',
                      iconByStatus: true,
                      hideText: false,
                      width: 180,
                    }}
                    onSingleSubmit={onSingleSubmit}
                    pagination={true}
                    onReload={handleReload}
                    loading={isReLoading}
                  />
                  <br />
                </>
              )}

              <Row
                ref={(section) => {
                  setSection(section)
                }}
              >
                {singleError && (
                  <>
                    <Message
                      showIcon
                      type="error"
                      description={`ดึงข้อมูลโครงการ ${singleProject?.projectName} ไม่สำเร็จ`}
                    />
                    <br />
                  </>
                )}
              </Row>

              {proposalStrategic && (
                <>
                  <Strategic
                    schema={proposalStrategic}
                    //showCommandButton={isEnableEdit && !proposalStrategic.disabled}
                    showCommandButton={!proposalStrategic.disabled}
                    projectVersionId={singleProject.id}
                    isEdit={isEditWidget.strategic}
                    onChangeIsEdit={(_isEdit) =>
                      handleOnChangeIsEdit('strategic', _isEdit, setIsEditWidget)
                    }
                    onComplete={onComplete}
                    isReview
                  />
                  <br />
                </>
              )}
            </>
          )}
        </>
      )}
    </SidebarProposal>
  )
}
